function initPersonal() {
	require.ensure(['./personal-module.js'], function (require) {
		require('./personal-module.js');
	});
}

var elements = $('#hidden-main, #hidden-chairman, #financial-results');
if (elements.length) {
	initPersonal();
}



/** WEBPACK FOOTER **
 ** ./frontend/components/personal/personal.js
 **/